import React from 'react'
import './ProgressiveHero.css';
import mainimage from '../assetsprogressive/mainimage.png';

export default function ProgressiveHero() {
  return (
    <div id='progressive-hero' className="progressive-wrapper">
 <div className="left">
        <h1>Best Progressive Web App Development Company in India</h1>
        <p>
       BastionEx, India’s top IT company, delivers PWAs with 90+ Lighthouse scores, 40% higher engagement, and native-like speed. Achieve superior speed, offline reliability, and measurable boosts in user engagement and conversions.
 </p>
      </div>
      <div className="right">
        <img src={mainimage} alt="error" />
      </div>
    </div>
  )
}
